import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { TabList, Tabs, Tab } from 'aquilla/core/molecules/Tabs';
import { BlockTypeToLabel } from './constants';

const StyledTabs = styled(Tabs)`
  margin-bottom: ${Spacings.SPACING_12B};
  position: sticky;
  top: ${Spacings.SPACING_18B};
  z-index: 1;
  background: var(--color-base-1);
  ${mediaQuery.uptoMobile} {
    width: 100%;
    top: ${Spacings.SPACING_12B};
    margin-bottom: ${Spacings.SPACING_0B};
  }
`;

const StyledTabsList = styled(TabList)`
  border-bottom: 1px solid var(--color-divider);
  ${mediaQuery.uptoMobile} {
    height: 20px;
  }
`;

const NotesTabs = ({ tabsData, onChange, selectedTabIndex, children }) => {
  return (
    <>
      <StyledTabs index={selectedTabIndex} onChange={onChange}>
        <StyledTabsList>
          {tabsData?.map((block) => {
            return (
              <Tab key={block.blockType}>
                {BlockTypeToLabel[block.blockType]}
              </Tab>
            );
          })}
        </StyledTabsList>
        {children}
      </StyledTabs>
    </>
  );
};

export default NotesTabs;
